const isLocalhost = require("../environment/isLocalhost");

/**
 * @param subject {string}
 * @param message {string}
 * @return {Promise<void>}
 */
module.exports = async function sendEmailToFormsAtIterableCom(subject, message) {
    if (isLocalhost()) {
        return;
    }

    const url = 'https://itblapi.wpenginepowered.com/wp-json/itblbackend/v1/send-email';

    const payload = {
        subject,
        message
    };

    try {
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        // Failsafe
    }
}